import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  input,
  output,
  computed
} from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormGroup } from '@angular/forms';

import * as olciUtil from '../../../util';
import { MicroServicesService } from '../../core/services/micro-services.service';
@Component({
    selector: 'app-guest-selection-for-checkin',
    templateUrl: './guest-selection-for-checkin.component.html',
    styleUrls: ['./guest-selection-for-checkin.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GuestSelectionForCheckinComponent {
	public readonly bundle = input<any>();
	public readonly guestsNotCompleted = input<any[]>([]);
	public readonly language = input<any>();
	public readonly onSubmit = output<any>();
	public readonly selectItem = output<any>();
	public readonly associateGuests = output<void>();
    public readonly guests = computed(() => 
        this.guestsNotCompleted().map(g => ({ ...g, selectedForCheckin: g.selectedForCheckin ?? true }))
    );

	public guestSelectorCheckbox: UntypedFormGroup;

	public brandName:string;

	constructor(
		private readonly location: Location, 
		private readonly microService: MicroServicesService) {
		this.brandName = this.microService.brand;
	}

	goBack(event: any) {
		event.preventDefault();
		this.location.back();
	}

	addGuests() {
		this.associateGuests.emit();
	}

	getGuestLastName(guest: any) {
		return olciUtil.getGuestLastName(guest);
	}
 
    selectGuest(event: any, guestId: number) {
        const guest = this.guests().find(g => g.guestId === guestId);
        if (guest) {
            this.selectItem.emit(event?.detail?.id);
            guest.selectedForCheckin = event?.detail?.id?.isSelected;
        }
    }
 
    getDataForItemSelector(guest: any) {
        const data = {
          id: guest.guestId,
          title: guest.firstName + ' ' + this.getGuestLastName(guest),
          subTitle: '',
          img: guest.base64Image
        };
        return JSON.stringify(data);
    }
}
